module.exports = __webpack_public_path__ + "static/functions-screen-7-3c97bda2e8f6f9da9a3153abbead1db5.png";